class GooglePlaces {
	constructor(config) {
		this.service  = new google.maps.places.AutocompleteService();
		this.geocoder = new google.maps.Geocoder();
		this.config   = config || {};
		this.postcode = null;
		this.location = null;
		this.config.radius = this.config.radius || 60000; //60km containment
	}

	/**
	 * @param  {String}   address  [description]
	 * @param  {Function} callback [description]
	 * @return {null}
	 */
	predict(address, callback) {
		'use strict';
		var options = this.getOptions(address);
		this.service.getPlacePredictions(options, callback);
	}

	/**
	 * @param  {String} address [description]
	 * @return {Object}
	 */
	getOptions(address) {
		'use strict';
		var options = {
			input: address,
			types: ['geocode']
		};

		this.setCountryOption(options);

		/**
		 * @todo - reenable with workaround
		 */
		//	.setLocationBias(options);

		return options;
	}

	/**
	 * @param {Object} options [description]
	 * @return {GooglePlaces} [description]
	 */
	setCountryOption(options) {
		'use strict';

		if (!this.config.country) {
			return this;
		}

		options.componentRestrictions         = {};
		options.componentRestrictions.country = this.config.country;

		return this;
	}

	/**
	 * Contrary to the docs
	 * @see https://developers.google.com/places/documentation/autocomplete#location_biasing
	 * You cannot restrict by location/radius
	 * @see http://stackoverflow.com/questions/13702720/google-map-api-autocomplete-restricted-bias-to-street-address-in-my-town
	 * @param {Object} options [description]
	 * @return GooglePlaces
	 */
	setLocationBias(options) {
		'use strict';

		if (true) {
			return this;
		}

		options.location = this.location;
		options.radius   = this.config.radius;

		return this;
	}

	/**
	 * @param {String} postcode [description]
	 */
	setPostcode(postcode) {
		'use strict';
		this.getLocationFromPostcode(postcode);
		return this;
	}

	/**
	 * @param  {String} postcode
	 * @return {null}
	 */
	getLocationFromPostcode(postcode) {
		'use strict';

		this.geocoder.geocode({
			address: '',
			componentRestrictions: {
				country : this.config.country,
				postalCode : postcode
			}
		}, $.proxy(this.parseGeocodeResult, this));
	}

	/**
	 * @param  {Array} result [description]
	 * @return {String}
	 */
	parseGeocodeResult(result) {
		'use strict';
		var latLng;
		if (result && result.length) {

			latLng = result[0].geometry.location;
			this.location = this.formatLocation(latLng);
		}
	}

	/**
	 * @param  {google.maps.LatLng} latLng [description]
	 * @return {String}
	 */
	formatLocation(latLng) {
		'use strict';
		return latLng.lat() + ',' + latLng.lng();
	}
}

export default GooglePlaces;